var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuvector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 57,
    viewBox: "0 0 71 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 1H2.46809V12.8919H68.5319L70 1Z",
    fill: "#202258"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0638 21.8108H2.46809L3.93617 27.7567V33.7026H67.0638V21.8108Z",
    fill: "#252762"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 56H67.0639L65.5958 50.0541V44.1081L3.93617 42.6216L1 56Z",
    fill: "#252762"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1H2.46809V12.8919H68.5319L70 1Z",
    stroke: "#202258"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0638 21.8108H2.46809L3.93617 27.7567V33.7026H67.0638V21.8108Z",
    stroke: "#202258"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 56H67.0639L65.5958 50.0541V44.1081L3.93617 42.6216L1 56Z",
    stroke: "#202258"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuvector);
export default __webpack_public_path__ + "static/media/menuvector.c5d3542d46e919af5f1ed4814484f339.svg";
export { ForwardRef as ReactComponent };